import { render, staticRenderFns } from "./SessionTabs.vue?vue&type=template&id=485e8718"
import script from "./SessionTabs.vue?vue&type=script&lang=js"
export * from "./SessionTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports